import _ from "underscore";
const subscriptionBenefits = [
    "Curated box",
    "Selected merch from our store",
    "A cool graphic tee",
    "Heirloom farm box",
    "Book club subscription",
    "Curated cocktail kit",
    "Exclusive test batches",
    "Artisanal bath bombs",
    "Freshly squeezed juices",
    "Signed limited-edition merch",
    "Pink vinyl LP",
    "New flavor-of-the-month",
    "Handmade jewelry",
    "Awesome socks",
    "Tea sampler pack",
    "Craft chocolate bar",
];
const regularBenefits = [
    "Early access to new releases",
    "Signed copies of featured books",
    "Personal reading recommendations from our staff",
    "Access to members-only book club meetings",
    "Vote on our book-of-the-month",
    "Access to our rare books collection",
    "Free shipping on all orders",
    "Free returns on all orders",
    "Exclusive author meet & greets",
];
export function randomSubscriptionBenefit() {
    return _.sample(subscriptionBenefits);
}
export function randomRegularBenefit() {
    return _.sample(regularBenefits);
}
